export default __webpack_public_path__ + "static/media/fighting.565818ad.svg";